export const IconHand = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconHand_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconHand_svg__a)">
        <path d="M12.8 23a8.2 8.2 0 0 1-3.85-.937A8 8 0 0 1 6 19.45l-4.425-6.5a.74.74 0 0 1-.137-.537.82.82 0 0 1 .237-.488q.5-.525 1.238-.6.737-.075 1.337.35l2.75 1.9V4q0-.424.288-.712A.97.97 0 0 1 8 3q.424 0 .713.288Q9 3.575 9 4v11.5q0 .6-.537.887-.538.288-1.038-.062L5.3 14.85l2.375 3.45A6.14 6.14 0 0 0 9.9 20.288a6.1 6.1 0 0 0 2.9.712q2.576 0 4.387-1.812Q19 17.375 19 14.8V5q0-.424.288-.713A.97.97 0 0 1 20 4q.424 0 .712.287Q21 4.576 21 5v9.8q0 3.424-2.387 5.813Q16.224 23 12.8 23M12 1q.424 0 .713.288Q13 1.575 13 2v9q0 .424-.287.713A.97.97 0 0 1 12 12a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 11V2q0-.424.287-.712A.97.97 0 0 1 12 1m4 1q.424 0 .712.288Q17 2.575 17 3v8q0 .424-.288.713A.97.97 0 0 1 16 12a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 11V3q0-.424.287-.712A.97.97 0 0 1 16 2" />
      </g>
    </svg>
  );
};
